var chunkToChildrenMap = {
	"2831": [
		710,
		3387
	],
	"3147": [
		710,
		3387
	],
	"5839": [
		8240
	],
	"6254": [
		710,
		3387
	],
	"7552": [
		8849,
		7343,
		6614,
		8823,
		5839
	],
	"8117": [
		8849,
		7343,
		5345,
		9140,
		2408,
		6834
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}, () => {

}));